/**
 * Login Component
 * 
 * Displays login screen and initiates Okta authentication flow.
 */

import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const { oktaAuth, authState } = useOktaAuth();

  // If already authenticated, redirect to home
  if (authState?.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleLogin = async () => {
    try {
      await oktaAuth.signInWithRedirect();
    } catch (err) {
      console.error('Login error:', err);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img 
            src="/prajna.svg" 
            alt="Prajna Logo" 
            className="login-logo"
          />
          <h1>Auto-Approval Dashboard</h1>
        </div>

        <div className="login-content">
          <button 
            onClick={handleLogin}
            className="login-button"
            disabled={!authState}
          >
            {!authState ? 'Loading...' : 'Sign In with Okta'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
